import {SimpleModal} from "@components/base/overlays/Modal/SimpleModal";
import React from "react";
import {useRouter} from "next/router";

export function UpgradeModal({
                                 feature,
                                 isOwner
                             }: {
    feature: 'students' | 'leaders' | 'activities' | 'courses' | 'course',
    isOwner: boolean
}) {
    const router = useRouter()
    return <SimpleModal
        type="upgrade"
        title={feature == 'course' ? 'Access Restricted' : isOwner ? 'You’ve reached your plans limit' : 'Contact the course owner'}
        body={<>
            {feature == 'course'
                ? <div className={"px-16"}>
                    <p>
                        {isOwner
                            ? 'Access to this course is temporarily restricted. Please upgrade your plan to regain access.'
                            : 'Access to this course is temporarily restricted. Please contact the course owner for further details.'}
                    </p>
                </div>
                : <div className={"px-16"}>
                    <p>
                        You&apos;ve reached the maximum number of
                        <span className={"font-medium mx-1"}>{featureToString(feature)}</span>
                        that can be added to
                        {feature === 'courses' ? ' your account' : ' this course'}
                        {!isOwner && ' based on the course owner\'s plan'}
                    </p>
                    <br/>
                    {isOwner ? <p>
                            But don&apos;t let that stop you from sharing your knowledge with students.
                            <a href={'/account/billing'} className={"underline mx-1 hover:text-teal-600"}>Upgrade</a>
                            for higher limits and other great features.
                        </p>
                        : <p>
                            Please contact the course owner to upgrade their plan and increase course limits.
                        </p>}
                </div>}
        </>}
        confirmLabel={
            feature == 'course' && !isOwner ? 'Okay' : 'View Plans'
        }
        cancelLabel={feature == 'course' && !isOwner ? null : 'Cancel'}
        onConfirm={
            () => {
                router.push('/account/billing', undefined, {shallow: true});
            }
        }
    />
}

function featureToString(feature: string) {
    switch (feature) {
        case 'students':
            return 'students';
        case 'leaders':
            return 'course leaders';
        case 'activities':
            return 'Assignments and Quizzes';
        case 'courses':
            return 'new courses';
    }
}
